import { useState } from 'react'
import type { FormEvent } from 'react'
import { Link } from '@tanstack/react-router'
import { apiUrl } from '../../lib/api'
import { useT } from '../../i18n'
import { AuthShell } from './AuthShell'

const COPY = {
  en: { title: 'Reset your password', description: 'Enter your email and we will send a secure reset link.', email: 'Email address', submit: 'Send reset link', loading: 'Sending…', sent: 'If an account exists for this email, a reset link is on its way.', back: 'Back to sign in' },
  tr: { title: 'Parolanı sıfırla', description: 'E-posta adresini gir; güvenli bir sıfırlama bağlantısı gönderelim.', email: 'E-posta adresi', submit: 'Sıfırlama bağlantısı gönder', loading: 'Gönderiliyor…', sent: 'Bu e-postaya bağlı bir hesap varsa sıfırlama bağlantısı gönderildi.', back: 'Girişe dön' },
} as const

export function ForgotPasswordPage() {
  const t = useT<Record<string, string>>(COPY)
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    if (loading) return
    setLoading(true)
    try {
      await fetch(apiUrl('/auth/forgot-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      }).catch(() => undefined)
    } finally {
      setSubmitted(true)
      setLoading(false)
    }
  }

  return (
    <AuthShell title={t.title} description={t.description}>
      {submitted ? (
        <div className="pex-auth-form">
          <div className="pex-auth-feedback" data-tone="success" role="status">{t.sent}</div>
          <div className="pex-auth-row"><Link to="/login">← {t.back}</Link></div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="pex-auth-form">
          <div className="pex-auth-field">
            <label htmlFor="forgot-email">{t.email}</label>
            <input id="forgot-email" type="email" autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} required className="pex-auth-input" />
          </div>
          <button type="submit" disabled={loading} className="pex-auth-submit">{loading ? t.loading : t.submit}</button>
          <div className="pex-auth-row"><Link to="/login">← {t.back}</Link></div>
        </form>
      )}
    </AuthShell>
  )
}
